export const msgParams = {
  msgType: "success",
  msgDesc: "",
  msg: "",
  msgShow: false
};

export const LOADING_OPTIONS = {
  lock: true,
  spinner: "el-icon-loading",
  background: "rgba(0,0,0,.3)"
};

// facebook权限列表
export const FB_PERMISSIONS = {
  // 基本权限
  // basic: 'ads_read,email,ads_management,manage_pages,public_profile,read_insights,publish_actions',
  // // 用户权限
  // user: 'email,user_hometown,user_likes,user_status,user_location,user_tagged_places,user_birthday,user_photos,user_videos,user_posts,user_friends,publish_video,user_age_range,user_gender,user_link',
  // // 活动、小组、主页权限
  // aghp: 'ads_management,pages_messaging,read_page_mailboxes,ads_read,business_management,pages_messaging_phone_number,user_events,manage_pages,pages_messaging_subscriptions,pages_manage_cta,pages_show_list,pages_manage_instant_articles,publish_pages',
  // // 其他权限
  // other: 'instagram_basic,instagram_manage_insights,read_insights,instagram_manage_comments,leads_retrieval,read_audience_network_insights,groups_access_member_info,publish_to_groups',
  all: function () {
    // return [this.basic, this.user, this.aghp, this.other].join(',');
    return 'ads_management,ads_read,manage_pages,business_management,email,default'
  }
};

export const getQueryString = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.href.substring(window.location.href.indexOf('?')).substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const addZero = val => {
  return val < 10 ? '0' + val : val;
};

export const getCurrentDate = () => {
  const date = new Date();

  return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`;
};

export const getPage = (currentPage, totalPage) => {
  var arr = [],
    i = 0;
  // 总页数小于5
  if (totalPage <= 5) {
    // 全部显示
    for (i = 0; i < totalPage; i++) {
      arr.push({
        value: i + 1,
        disable: i + 1 === currentPage
      });
    }
  } else { // 总页数大于5
    // 当前页小于5
    if (currentPage < 5) {
      // 加载前5页
      for (i = 0; i < 5; i++) {
        arr.push({
          value: i + 1,
          disable: i + 1 === currentPage
        });
      }
      arr.push({
        value: '…',
        disable: true,
        none: true
      }); // 中间页省略
      arr.push({
        value: totalPage,
        disable: false
      }); // 显示最后一页
    } else {
      // 当前页大于5时
      // 将第一页及省略页加进数组
      console.log(currentPage);
      arr.push({
        value: 1,
        disable: false
      });
      arr.push({
        value: '…',
        disable: true,
        none: true
      });
      // 如果当前页为倒数第二页
      if (currentPage + 1 === totalPage) {
        // 加载当前页的前两页
        for (i = currentPage - 2; i < totalPage - 1; i++) {
          arr.push({
            value: i + 1,
            disable: i + 1 === currentPage
          });
        }
      } else if (currentPage === totalPage) { // 如果当前页为最后一页
        // 加载前三页
        for (i = currentPage - 3; i < totalPage - 1; i++) {
          arr.push({
            value: i + 1,
            disable: i + 1 === currentPage
          });
        }
      } else {
        // 如果当前页在中间  加载前两页及后一页
        for (i = currentPage - 3; i < currentPage + 1; i++) {
          arr.push({
            value: i + 1,
            disable: i + 1 === currentPage
          });
        };
      }
      if (currentPage < totalPage - 2) {
        arr.push({
          value: '…',
          disable: true,
          none: true
        });
      }
      // 加载最后一页
      arr.push({
        value: totalPage,
        disable: currentPage === totalPage
      });
    }
  }
  // 返回页码数据
  return arr;
}
